import axios from "@/api/axios";

async function saveCutReportSettings(jsonObj) {
  if (!jsonObj) return false;
  let retval = false;
  try {
    console.log("saveCutReportSettings request");
    let url = "/api/report/saveCutReportSettings";
    let formData = new FormData();
    let blob = new Blob([JSON.stringify(jsonObj)], {
      type: "text/plain",
    });

    formData.append("file", blob, "cutReportSettings.json");
    formData.append("patientId", vueApp.patientId);
    formData.append("s3Path", vueApp.stlBaseUrl);
    var config = {};
    config.headers = {
      "content-type": "multipart/form-data",
    };

    const response = await axios.post(url, formData, config);
    retval = response.status == 200;
    console.log("saveCutReportSettings", response);
  } catch (error) {
    console.error("saveCutReportSettings", error);
  }
  return retval;
}

async function saveCutReportPdfInS3(blob, filename) {
  if (!blob) return false;

  if (!filename) {
    filename = "cutsReport.pdf";
  }

  let retval = false;
  try {
    console.log("saveCutReportPdfInS3 request");
    let url = "/api/report/saveCutReportPdf";
    let formData = new FormData();

    formData.append("file", blob, filename);
    formData.append("patientId", vueApp.patientId);
    formData.append("s3Path", vueApp.stlBaseUrl);
    var config = {};
    config.headers = {
      "content-type": "multipart/form-data",
    };

    const response = await axios.post(url, formData, config);
    retval = response.status == 200;
    console.log("saveCutReportPdfInS3", response);
  } catch (error) {
    console.error("saveCutReportPdfInS3", error);
  }
}

async function sendGetCutReportsRequest() {
  try {
    console.log("sendGetCutReportsRequest");
    let url = `/api/report/getCutReports`;
    let requestData = {
      patientId: vueApp.patientId,
      s3Path: vueApp.stlBaseUrl,
    };
    const response = await axios.get(url, { params: requestData });
    const responseData = response.data;
    return responseData.value;
  } catch (e) {
    console.log("sendGetCutReportsRequest error", e);
    return false;
  }
}

async function sendGetPdfReportDataRequest(callBack) {
  let responseData = {
    doctor_number: vueApp.doctorId,
    icon: vueApp.doctorLogo,
    iconWidth: 0,
    iconHeight: 0,
    iconDataUrl: vueApp.doctorLogo,
    patient_first_name: vueApp.patientFirstName,
    patient_last_name: vueApp.patientLastName,
    age: vueApp.age,
    cephDate: vueApp.cephDate, //"" + new Date(),
    analysisDate: vueApp.cephDate,
    gender: "Male",
    doctor_first_name: vueApp.doctorFirstName,
    doctor_last_name: vueApp.doctorLastName,
  };
  try {
    let isLocalData = !!vueApp.logo;
    let url = "/api/report/getPdfReportData";
    let requestData = {
      patientId: vueApp.patientId,
      serverTag: vueApp.prefix,
      s3Url: vueApp.s3Url,
      isStaging: !!vueApp.isStaging,
    };
    if (isLocalData) requestData.icon = `${vueApp.s3Url}/dLogo/${vueApp.logo}`;
    const response = await axios.get(url, { params: requestData });
    if (response.data && response.data.doctor_number) {
      responseData = response.data;
      console.log("getPdfReportData response", responseData);
    }
    // if (isLocalData) {
    //   responseData.doctor_number = vueApp.doctorId;
    //   responseData.patient_first_name = vueApp.patientFirstName;
    //   responseData.patient_last_name = vueApp.patientLastName;
    //   responseData.age = vueApp.age;
    //   responseData.cephDate = vueApp.cephDate;
    // }
  } catch (e) {
    console.log("sendGetPdfReportDataRequest error", e);
  }

  if (callBack) {
    // let iconUrl = data.icon;
    // let blob = await fetch(iconUrl).then((r) => r.blob());
    // let dataUrl = await new Promise((resolve) => {
    //   let reader = new FileReader();
    //   reader.onload = () => resolve(reader.result);
    //   reader.readAsDataURL(blob);
    // });
    // data.iconDataUrl = dataUrl;
    callBack(responseData);
  }
  return responseData;
}

async function sendRemovePdfReportRequest(report) {
  let url = "/api/report/removePdfReport";
  console.log("sendRemovePdfReportRequest request", report.name);
  let data = {
    patientId: vueApp.patientId,
    s3Path: vueApp.stlBaseUrl,
    name: report.name,
    directory: report.directory,
  };
  let stringData = JSON.stringify(data);
  let config = {};
  config.headers = {
    "content-type": "application/json",
  };
  const response = await axios.post(url, stringData, config);
  console.log("sendRemovePdfReportRequest response", response);
  return response;
}

async function sendGetExportDataRequest(callBack) {
  let responseData = {
    cbctUrl: null,
    iosUrl: null,
    iosSegmentedUrl: null,
    stitchedUrl: null,
    nonStitchedUrl: null,
    airwayReportUrl: vueApp.airways.length ? vueApp.airways[0] : null,
    fromServer: false,
  };
  // https://s3.us-west-2.amazonaws.com/qa.cephx.com/STL/dicom-3175161723626821092/stl_transformed_dicom-3175161723626821092.zip
  responseData.cbctUrl = `${vueApp.dicomUrl}/dicom.zip`;

  if (vueApp.isStitched) {
    // https://s3.us-west-2.amazonaws.com/qa.cephx.com/dicom-3175161723626821092/stlCopy/stl_transformed_dicom-3175161723626821092.zip
    responseData.nonStitchedUrl = `${vueApp.stlCopyUrl}/desktop.zip`;
    responseData.stitchedUrl = `${vueApp.stlBaseUrl}/desktop.zip`;
    // stl_transformed_${vueApp.s3dicom}.zip`;
  } else {
    // https://s3.us-west-2.amazonaws.com/qa.cephx.com/STL/dicom-3175161723626821092/stl_transformed_dicom-3175161723626821092.zip
    responseData.nonStitchedUrl = `${vueApp.stlBaseUrl}/desktop.zip`;
  }

  if (vueApp.isIntraoral) {
    // https://s3.us-west-2.amazonaws.com/qa.cephx.com/STL/dicom-3175161723626821092/stl_segmentation_standalone_dicom-3175161723626821092.zip
    responseData.iosUrl = `${vueApp.stlBaseUrl}/stl_segmentation_standalone_${vueApp.s3dicom}.zip`;
    responseData.iosSegmentedUrl = `${vueApp.stlBaseUrl}/segmentation-standalone-desktop.zip`;
  }

  // https://qa.ceph-x.com/cephx/analysis/download?patnum=317516&docnum=1&patname=STITCHING%20Kea%20Test%2020240814%20&DocName=Zeev%20Abraham&data=Airway%20Volume&showLogo=true
  // responseData.airwayReportUrl = `https://qa.ceph-x.com/cephx/analysis/download?patnum=${vueApp.patientId}`;

  // responseData.nonStitchedUrl = "https://s3.us-west-2.amazonaws.com/qa.cephx.com/STL/dicom-3175161723626821092/stl_transformed_dicom-3175161723626821092.zip?response-content-disposition=attachment%3B%20filename%3D%22case-317516-stl.zip%22&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20240827T074017Z&X-Amz-SignedHeaders=host&X-Amz-Expires=899&X-Amz-Credential=AKIAWGBWWZKWMBVIQB6V%2F20240827%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Signature=256488af6761ff49e42ae2fb024332f2b1182bea51cad261c5f6ba029816a1fd";
  // https://s3.us-west-2.amazonaws.com/qa.cephx.com/STL/dicom-3175161723626821092/stl_transformed_dicom-3175161723626821092.zip
  // ?response-content-disposition=attachment%3B%20filename%3D%22case-317516-stl.zip%22&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20240827T074017Z&X-Amz-SignedHeaders=host&X-Amz-Expires=899&X-Amz-Credential=AKIAWGBWWZKWMBVIQB6V%2F20240827%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Signature=256488af6761ff49e42ae2fb024332f2b1182bea51cad261c5f6ba029816a1fd

  // if (callBack) {
  //   callBack(responseData);
  // }

  try {
    // console.log(
    //   "sendGetExportDataRequest",
    //   vueApp.patientId,
    //   vueApp.prefix,
    //   vueApp.s3Url
    // );
    let s3Url = vueApp.s3Url;
    let s3dicom = vueApp.s3dicom;
    if (vueApp.stlBaseUrl.includes("AI/STL")) {
      s3dicom = `AI/${s3dicom}`;
    }

    let url = "/api/report/getExportData";
    let requestData = {
      docnum: vueApp.doctorId,
      docname: vueApp.doctorName,
      patientId: vueApp.patientId,
      patientName: `${vueApp.patientFirstName} ${vueApp.patientLastName}`,
      serverTag: vueApp.prefix,
      s3Url: s3Url,
      s3dicom: s3dicom,
      // isStitched: vueApp.isStitched,
    };
    const response = await axios.get(url, { params: requestData });
    responseData = response.data;
    responseData.fromServer = true;
    responseData.time = Date.now();
    responseData.airwayReportUrl = vueApp.airways.length
      ? vueApp.airways[0]
      : null;
  } catch (e) {
    console.log("sendGetExportDataRequest error", e);
  }
  if (callBack) {
    callBack(responseData);
  }

  return responseData;
}

async function getPresignedUrl(cfrUrl) {
  try {
    let url = "/api/report/getPresignedUrl";
    let requestData = {
      cfrUrl: cfrUrl,
    };
    const response = await axios.get(url, { params: requestData });
    return response.data;
  } catch (e) {
    console.log("getPresignedUrl error", e);
  }
}

async function getPresignedUrls(cfrUrls) {
  try {
    let url = "/api/report/getPresignedUrls";
    let requestData = {
      cfrUrls: cfrUrls,
    };
    const response = await axios.get(url, {
      params: requestData,
      paramsSerializer: {
        indexes: null, // Forces URL format: ?tags=csharp&tags=dotnet&tags=webapi
      },
    });
    return response.data;
  } catch (e) {
    console.log("getPresignedUrls error", e);
  }
}

export {
  saveCutReportSettings,
  saveCutReportPdfInS3,
  sendRemovePdfReportRequest,
  sendGetCutReportsRequest,
  sendGetPdfReportDataRequest,
  sendGetExportDataRequest,
  getPresignedUrl,
  getPresignedUrls,
};
